import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25e6aeb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "autoList__content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " - ", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "fl-row" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_app_operates = _resolveComponent("app-operates")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_AddCardModal = _resolveComponent("AddCardModal")!
  const _component_DistributeModal = _resolveComponent("DistributeModal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer autoList" }, {
    title: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: _ctx.sldPageTitle('#1890ff', '折扣卡批次')
      }, null, 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form, {
          class: "fl-clean autoList__filterForm",
          form: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "批次ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.batchId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.batchId) = $event)),
                  class: "filterInput",
                  "allow-clear": "",
                  placeholder: "批次ID"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "企业名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_enterprise_input, {
                  value: _ctx.filterParams.enterpriseId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.enterpriseId) = $event)),
                  style: {"width":"200px"},
                  "disable-in-open": "",
                  "with-default-all": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.approveStatus,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.approveStatus) = $event)),
                  style: {"width":"180px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditStatusEnum, (objVal, objKey) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: objKey,
                        value: objKey
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(objVal), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "使用渠道" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.useChannel,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterParams.useChannel) = $event)),
                  style: {"width":"180px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelTypeEnum, (objVal, objKey) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: objKey,
                        value: objKey
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(objVal), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "申请时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.applyTime,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterParams.applyTime) = $event)),
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _ctx.onRefreshTable
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"]),
        (_ctx.isShowApplyBtn)
          ? (_openBlock(), _createBlock(_component_app_operates, {
              key: 0,
              mg: "0 0 10px 0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onShowCard
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建折扣卡")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          "show-pagination": true,
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          "row-selection": _ctx.selectState,
          scroll: { x: true }
        }, {
          effectiveDays: _withCtx(({ record }) => [
            (record.fixedTermFlag===1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", null, _toDisplayString(record.effectiveStartDate), 1),
                  _hoisted_4,
                  _createElementVNode("div", null, _toDisplayString(record.effectiveEndDate), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(`发放后 ${record.effectiveDays} 天`), 1))
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_6, [
              (['REVIEWED','NO_NEED_REVIEW'].includes(record.approveStatus))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _withModifiers(($event: any) => (_ctx.goBatchDetail(record)), ["prevent"])
                    }, "查看", 8, _hoisted_7),
                    _hoisted_8,
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _withModifiers(($event: any) => (_ctx.onInvalid(record)), ["prevent"])
                    }, "作废", 8, _hoisted_9),
                    _hoisted_10,
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _withModifiers(($event: any) => (_ctx.onDistribute(record)), ["prevent"])
                    }, "分配员工", 8, _hoisted_11),
                    _hoisted_12
                  ], 64))
                : _createCommentVNode("", true),
              (['REVIEW'].includes(record.approveStatus))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _withModifiers(($event: any) => (_ctx.onCancel(record)), ["prevent"])
                  }, "撤销", 8, _hoisted_13))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["columns", "data", "row-selection"])
      ]),
      (_ctx.showModal)
        ? (_openBlock(), _createBlock(_component_AddCardModal, {
            key: 0,
            ref: "addCardRef",
            onClose: _ctx.closeModal
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true),
      (_ctx.showDistributeModal)
        ? (_openBlock(), _createBlock(_component_DistributeModal, {
            key: 1,
            "batch-info": _ctx.batchInfo,
            onClose: _ctx.closeDistributeModal
          }, null, 8, ["batch-info", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}